import { createReducer } from '@reduxjs/toolkit';
import { TYPES } from '../../common/constants';

const fetchMessagesDone = (_, { payload }) => {
    return [
        ...payload
    ]
}

const postMessageDone = ( Messages, {payload}) =>{
    return [
        payload,...Messages
    ]
}

const clearMessagesDone = ( ) => {
    return initialState
}
  
const initialState = [];

export default createReducer(initialState, {
    [TYPES.FETCH_MESSAGES_DONE]: fetchMessagesDone,
    [TYPES.POST_MESSAGE_DONE]:postMessageDone,
    [TYPES.CLEAR_MESSAGES]: clearMessagesDone
});
